<fieldset *ngIf="isVersion2()" [disabled]="isWorkflowOnSubscriber">
  <div class="row d-flex align-items-center">
    <div class="col-sm-12">
      <h2 class="text-primary mb-0">
        {{cardConfiguration.title}}
      </h2>
      <p></p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 form-group" style="display:inline !important">
      <label for="DifferentRenumerations3">
        <span class="mandatory">*</span>Nos dois últimos anos, o subscritor exerceu sucessivamente dois ou mais cargos a que a lei em vigor â data dos factos previstos no n.º 2 do artigo 33.º atribua remunerações diferentes (N.º 1 do Artigo 50 do EA)?
      </label>

      <div class="btn-group btn-group-toggle col-sm-4"  style="padding-left:0 !important">
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.differentRenumerations3" [radioLabel]="differentRenumerations3">
          <input type="radio" [(ngModel)]="cardData.differentRenumerations3" name="differentRenumerations3" #differentRenumerations3="ngModel" [value]="domain.value" required>
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 form-group" style="display:inline !important">
      <label for="DifferentOffices3">
        <span class="mandatory">*</span>Nos últimos três anos, o subscritor exerceu cargos dirigentes em regime de comissão de serviço (N.º1 do artigo 51.º do EA)?
      </label>

      <div class="btn-group btn-group-toggle col-sm-4"  style="padding-left:0 !important" >
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.differentOffices3" [radioLabel]="differentOffices3">
          <input type="radio" [(ngModel)]="cardData.differentOffices3" name="differentOffices3" #differentOffices3="ngModel" [value]="domain.value" required>
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 form-group" style="display:inline !important">
      <label for="DifferentRegimes3">
        <span class="mandatory">*</span>Nos últimos três anos, o subscritor prestou serviço em diferentes regimes de trabalho, que correspondem a aumento sobre a remuneração devida em regime de tempo completo ou integral (N.º2 do Artigo 51.º do EA)?
      </label>

      <div class="btn-group btn-group-toggle col-sm-4"  style="padding-left:0 !important">
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.differentRegimes3" [radioLabel]="differentRegimes3">
          <input type="radio" [(ngModel)]="cardData.differentRegimes3" name="differentRegimes3" #differentRegimes3="ngModel" [value]="domain.value" required>
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>

  <div class="row d-flex align-items-center">
    <div class="col-sm-8">
      <h3 class="mb-0">
        {{'CardRemunerationsLastUntilCutoff.OtherRemunerations' | translate}}
      </h3>
    </div>
    <div class="col-sm-4 text-end">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              aria-label="Nova entrada" type="button" class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>


    <!--New table entry inputs-->
    <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
      <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
        <span aria-hidden="true" class="icon-close text-primary"></span>
      </button>
      <h3 class="text-primary">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.AddItem' | translate}}</h3>
      <remuneration-period-table-edit *ngIf="expandNewEntry" [itemList]="cardData.remunerationsList" (listChanged)="onRemunerationsListChanged($event)"></remuneration-period-table-edit>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.JobPosition' | translate}}</th>
          <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.Start' | translate}}</th>
          <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.End' | translate}}</th>
          <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.ScheduleType' | translate}}</th>
          <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.RemunerationValue' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let tableItem of cardData.remunerationsList; let i = index">
          <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td class="align-items-center">
              <i rowExternalValidation="remunerationsList" [tableIndex]="i"></i>
              {{tableItem.jobPosition}}
            </td>
            <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
            <td class="fitwidth">{{tableItem.endDate | date : 'yyyy-MM-dd'}}</td>
            <td>{{tableItem.scheduleTypeCode | commonData : scheduleTypes: 'code' : 'desc'}}</td>
            <td>{{tableItem.remunerationValue | commaToPoint | currency:'EUR':'symbol':undefined:'pt-PT'}}</td>
            <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
              </button>
              <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.remunerationsList, i,$event)">
                <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="6" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <remuneration-period-table-edit [itemList]="cardData.remunerationsList" [editIndex]="i" (listChanged)="onRemunerationsListChanged($event)"></remuneration-period-table-edit>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <validation-message *ngIf="atLeastOneEntry === true && cardData.remunerationsList.length < 1" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>
</fieldset>

<fieldset *ngIf="!isVersion2()" [disabled]="isWorkflowOnSubscriber">

  <div class="row mt-5 d-flex align-items-center">
    <div class="col-sm-8">
      <h2 class="mb-0">
        {{cardConfiguration.title}}
      </h2>
    </div>
    <div class="col-sm-4 text-end">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              aria-label="Nova entrada" type="button" class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.AddItem' | translate}}</h3>
    <remuneration-period-table-edit *ngIf="expandNewEntry" [itemList]="cardData.remunerationsList" (listChanged)="onRemunerationsListChanged($event)"></remuneration-period-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.JobPosition' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.Start' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.End' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.ScheduleType' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastThreeYears.RemunerationsPeriodTable.RemunerationValue' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.remunerationsList; let i = index">
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td class="align-items-center">
            <i rowExternalValidation="remunerationsList" [tableIndex]="i"></i>
            {{tableItem.jobPosition}}
          </td>
          <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
          <td class="fitwidth">{{tableItem.endDate | date : 'yyyy-MM-dd'}}</td>
          <td>{{tableItem.scheduleTypeCode | commonData : scheduleTypes: 'code' : 'desc'}}</td>
          <td>{{currencyFormat(tableItem.remunerationValue)}} €</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
            </button>
            <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.remunerationsList, i,$event)">
              <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="6" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <remuneration-period-table-edit [itemList]="cardData.remunerationsList" [editIndex]="i" (listChanged)="onRemunerationsListChanged($event)"></remuneration-period-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>

<!--<pre>{{cardData | json}}</pre>-->
